import React from 'react'
import { Button } from 'semantic-ui-react'
import Link from 'next/link'

const CTA = () => (
  <div
    css={{
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <Link href="/signup">
      <Button as="a" size="large" primary>
        Get Alerts Now
      </Button>
    </Link>
  </div>
)

export default CTA
